import React from 'react';
import { useAppLaunch } from 'contexts/AppLaunch';
import { useUserAuth } from 'contexts/UserAuth';
import { useGlobalConfig } from 'contexts/GlobalConfig';

const { useState } = React;

const PageLayout = (props) => {
  const { children } = props;
  const { notifications } = useAppLaunch();
  const { menubarHeight } = useGlobalConfig();
  const { user } = useUserAuth();
  const [showReviewModal, setShowReviewModal] = useState(false);

  return (
    <div
      style={{
        '--notification-height': notifications.length > 0 ? '45px' : '0px',
        '--mobile-tabbar-height': '64px',
      }}
    >
      <style jsx global>{`
        .globals-centerContentsMargin {
          margin-top: ${menubarHeight}px;
          margin-bottom: 0px;
        }

        @media (max-width: 1023px) {
          .globals-centerContentsMargin {
            margin-top: ${menubarHeight}px;
            margin-bottom: 64px;
          }
        }

        .globals-centerContentsMargin.withNoti {
          margin-top: calc(${menubarHeight}px + 45px);
        }

        @media (max-width: 1023px) {
          .globals-centerContentsMargin.withNoti {
            margin-top: calc(${menubarHeight}px + 45px);
          }
        }

        .index-header {
          height: 320px;
        }

        .index-header.withNoti {
          height: calc(320px + 45px);
        }

        @media (max-width: 1023px) {
          .index-header {
            // height: 287px;
            height: 320px;
          }
        }

        @media (max-width: 1023px) {
          .index-header.withNoti {
            // height: calc(287px + 45px);
            height: calc(320px + 45px);
          }
        }

        .index-header-maxWidthContainer {
          padding-top: ${menubarHeight}px;
        }

        .index-header-maxWidthContainer.withNoti {
          padding-top: calc(${menubarHeight}px + 45px);
        }

        @media (max-width: 1023px) {
          .index-header-maxWidthContainer {
            padding-top: ${menubarHeight}px;
          }
        }

        @media (max-width: 1023px) {
          .index-header-maxWidthContainer.withNoti {
            padding-top: calc(${menubarHeight}px + 45px);
          }
        }
      `}</style>

      {/* margin-top: calc(${menubarHeight}px + var(--notification-height, 0px)); */}

      {children}
    </div>
  );
};

export default PageLayout;
